module.exports = __webpack_public_path__ + "static/OpenSans-LightItalic-54b4443404115cef4af765596ccf0ed3.ttf";